module.exports = __webpack_public_path__ + "img/geofisica2_4-3_1536.2466a863.jpg";